// Author Lin
// Date 2024-06-24 11:22:19

class SithMesInventoryManualCheck {
    constructor({
                    id = null,
                    storageTypeId = '',
                    storageType = '',
                    materialTypeId = '',
                    materialType = '',
                    projectId = '',
                    projectCode = '',
                    materialCode = '',
                    materialName = '',
                    length = '',
                    width = '',
                    height = '',
                    weight = '',
                    currentQuantity = '',
                    unit = '',
                    storeKeeperLogin = '',
                    storeKeeperName = '',
                    warehouse = '',
                    storeLocation = '',
                    relatedDepart = '',
                    relatedDepartName = '',
                    comments = '',
                    remark = '',
                    storageStartTime = '',
                    latestOutputTime = '',
                    ids = ''
                }
                    = {}) {
        this.id = id;
        this.storageTypeId = storageTypeId;
        this.storageType = storageType;
        this.materialTypeId = materialTypeId;
        this.materialType = materialType;
        this.projectId = projectId;
        this.projectCode = projectCode;
        this.materialCode = materialCode;
        this.materialName = materialName;
        this.length = length;
        this.width = width;
        this.height = height;
        this.weight = weight;
        this.currentQuantity = currentQuantity;
        this.unit = unit;
        this.storeKeeperLogin = storeKeeperLogin;
        this.storeKeeperName = storeKeeperName;
        this.warehouse = warehouse;
        this.storeLocation = storeLocation;
        this.relatedDepart = relatedDepart;
        this.relatedDepartName = relatedDepartName;
        this.comments = comments;
        this.remark = remark;
        this.storageStartTime = storageStartTime;
        this.latestOutputTime = latestOutputTime;
        this.ids = ids;
    }
}

function newEntity() {
    return new SithMesInventoryManualCheck();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageTypeId',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.storageTypeId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageType',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.storageType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialTypeId',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.materialTypeId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialType',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.materialType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectId',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.projectId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.projectName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialName',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.materialName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'length',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.length',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'width',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.width',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'height',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.height',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'weight',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.weight',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'currentQuantity',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.currentQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unit',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.unit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storeKeeperLogin',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.storeKeeperLogin',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storeKeeperName',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.storeKeeperName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'warehouse',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.warehouse',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storeLocation',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.storeLocation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'relatedDepart',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.relatedDepart',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'relatedDepartName',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.relatedDepartName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'comments',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.comments',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageStartTime',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.storageStartTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'latestOutputTime',
            label: 'label.sith.inventory.sithMesInventoryManualCheck.grid.latestOutputTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    storageTypeIdFilter: '',
    storageTypeFilter: '',
    materialTypeIdFilter: '',
    materialTypeFilter: '',
    projectIdFilter: '',
    projectCodeFilter: '',
    materialCodeFilter: '',
    materialNameFilter: '',
    lengthFilter: '',
    widthFilter: '',
    heightFilter: '',
    weightFilter: '',
    currentQuantityFilter: '',
    unitFilter: '',
    storeKeeperLoginFilter: '',
    storeKeeperNameFilter: '',
    warehouseFilter: '',
    storeLocationFilter: '',
    relatedDepartFilter: '',
    relatedDepartNameFilter: '',
    commentsFilter: '',
    remarkFilter: '',
    storageStartTimeRteFilter: '',
    storageStartTimeLteFilter: '',
    createdTimeRteFilter: '',
    createdTimeLteFilter: '',
    latestOutputTimeRteFilter: '',
    latestOutputTimeLteFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'storageTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.storageType',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryManualStorageType'
            , correspondingField: 'storageName'
            , fieldsBindingByEntityModalSelected: '{"storageTypeId":"id"}'
        }
    },
    {
        key: 'materialTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.materialType',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryManualMaterialType'
            , correspondingField: 'materialTypeName'
            , fieldsBindingByEntityModalSelected: '{"materialTypeId":"id"}'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNameFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.materialName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lengthFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.length',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'widthFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.width',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'heightFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.height',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weightFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.weight',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'currentQuantityFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.currentQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unitFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.unit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storeKeeperNameFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.storeKeeperName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"storeKeeperLogin":"loginName"}'
        }
    },
    {
        key: 'warehouseFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.warehouse',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storeLocationFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.storeLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'relatedDepartNameFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.relatedDepartName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"relatedDepart":"id"}'
        }
    },
    {
        key: 'commentsFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.comments',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remarkFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.remark',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageStartTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.storageStartTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageStartTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.storageStartTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'latestOutputTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.latestOutputTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'latestOutputTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.filter.latestOutputTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'storageType',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.storageType',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryManualStorageType'
            , correspondingField: 'storageName'
            , fieldsBindingByEntityModalSelected: '{"storageTypeId":"id"}'
        }
    },
    {
        key: 'materialType',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.materialType',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryManualMaterialType'
            , correspondingField: 'materialTypeName'
            , fieldsBindingByEntityModalSelected: '{"materialTypeId":"id"}'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'projectCode'
            , fieldsBindingByEntityModalSelected: '{"projectId":"id"}'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.materialCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialName',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.materialName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'length',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.length',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'width',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.width',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'height',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.height',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weight',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.weight',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'currentQuantity',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.currentQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unit',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.unit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storeKeeperLogin',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.storeKeeperLogin',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storeKeeperName',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.storeKeeperName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"storeKeeperLogin":"loginName"}'
        }
    },
    {
        key: 'warehouse',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.warehouse',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storeLocation',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.storeLocation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'relatedDepartName',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.relatedDepartName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"relatedDepart":"id"}'
        }
    },
    {
        key: 'comments',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.comments',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageStartTime',
        label: 'label.sith.inventory.sithMesInventoryManualCheck.entity.storageStartTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
]

export {
    SithMesInventoryManualCheck, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
